<template>
    <div v-show="accessCheckFinished">
        <section class="section-container">
            <div
                v-if="res.status === 0"
                class="wrapper"
            >
                <div class="course-detail-page">
                    <div class="detail-right">
                        <detail-sidebar
                            :res="res"
                            :stop-sale-status="stopSaleStatus"
                            :getCode="getCode"
                            @handlePolling="handlePolling"
                            @goGrdoupRecor="goGrdoupRecor(res)"
                        />
                    </div>
                    <div class="detail-left">
                        <div class="detail-card">
                            <detail-card
                                v-if="renderBasic || Object.keys(res).length"
                                :res="res"
                                :from-index="fromIndex"
                                :stop-sale-status="stopSaleStatus"
                            />
                            <detail-lianbao-card :res="res" @buy-course="handleLianbaoNeed" />
                            <detail-info :res="res" :stop-sale-status="stopSaleStatus" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <page-loading v-if="isFetching" />
        <modal
            name="apply-success-popup"
            transition="nice-modal-fade"
            width="370"
            height="380"
            :click-to-close="false"
            @before-close="onBeforeCloseApplySuccessPopupHander"
        >
            <div v-if="divideIntoClassLoading" class="apply-success-popup" data-cy="qr-code-model">
                <div class="popup__head">
                    <i class="icon iconfont icon-xuanzhong"></i>恭喜您预约成功
                    <i
                        class="icon iconfont icon-guanbi"
                        @click="onCloseApplySuccessPopupHander()"
                    ></i>
                </div>
                <span class="line"></span>
                <div class="popup__body">
                    <div class="apply-wechat-code">
                        <img :src="require('~/assets/img/code_loading.gif')" alt="loading" data-cy="qr-code">
                    </div>
                    <div class="apply-wechat-footer">
                        正在为您分班，请稍等...
                    </div>
                </div>
            </div>
            <div v-else class="apply-success-popup" data-cy="qr-code-model">
                <div class="popup__head">
                    <i class="icon iconfont icon-xuanzhong"></i>{{returnData.display.title}}
                    <i
                        class="icon iconfont icon-guanbi"
                        @click="onCloseApplySuccessPopupHander()"
                    ></i>
                </div>
                <span class="line"></span>
                <div class="popup__body">
                    <div
                        class="apply-top"
                        @click="handleClick"
                        v-html="codeTopMessage"
                    >
                    </div>
                    <!-- <div class="apply-hint">{{display.top}}</div> -->
                    <div class="apply-wechat-code">
                        <img :src="returnData.QRCode" alt="code" data-cy="qr-code">
                    </div>
                    <div class="apply-wechat-footer">
                        {{returnData.display.bottom}}
                    </div>
                </div>
            </div>
        </modal>
        <modal
            name="apply-qrcode-popup"
            transition="nice-modal-fade"
            width="230"
            height="210"
            :click-to-close="false"
        >
            <div class="apply-qrcode-popup">
                <div data-cy="m-url-qr-code-model" class="popup_qrcode">
                    微信扫码报名
                    <i
                        class="icon iconfont icon-guanbi icon-qrcode-guanbi"
                        @click="onCloseApplyQrcodePopupHander"
                    ></i>
                    <div class="qrcode_img" data-cy="m-url-qr-code">
                        <vue-qr
                            :text="qrCodeUrl"
                            :logo-src="`//p.gsxcdn.com/819359550_wckxuflc.png`"
                            :margin="0"
                            :size="154"
                            :logo-scale="0.2"
                            :logo-margin="2"
                        />
                    </div>
                </div>
            </div>
        </modal>
        <modal
            name="countdown-popup"
            transition="nice-modal-fade"
            width="370"
            heigh="252 !important"
        >
            <div class="countdown-popup" data-cy="countdown-popup">
                <div class="popup__head">
                    <i class="icon iconfont icon-xuanzhong"></i>恭喜您预约成功
                    <i
                        class="icon iconfont icon-guanbi"
                        @click="onCloseApplySuccessPopupHander"
                    ></i>
                </div>
                <span class="line"></span>
                <div
                    v-if="res.direct_play && res.direct_play.action == 2"
                    class="popup__body"
                >
                    当前课程已有回放视频，
                    <span class="time"> {{count}} </span>秒后自动开始播放
                </div>
                <div
                    v-if="res.direct_play && res.direct_play.action == 1"
                    class="popup__body"
                >
                    当前课程正在进行，
                    <span class="time"> {{count}} </span>秒后自动进入直播间
                </div>
                <button
                    type="button"
                    class="quxiao_btn"
                    @click="onCloseHandler()"
                >
                    取消
                </button>
                <button
                    v-if="res.direct_play && res.direct_play.action == 2"
                    type="button"
                    class="enter_btn"
                    @click="onGotoPLaybackList(res)"
                >
                    立即观看
                </button>
                <button
                    v-if="res.direct_play && res.direct_play.action == 1"
                    type="button"
                    class="enter_btn"
                    @click="onLivehandler(res)"
                >
                    立即观看
                </button>
            </div>
        </modal>
        <skeleton-list v-if="isFetching" />
    </div>
</template>
<script>
/* eslint-disable max-lines-per-function, max-lines */
// eslint-disable-next-line no-unused-vars
import {mapGetters, mapState} from 'vuex';
import performance from '@base/mixins/performance';
import DetailSidebar from '@business/components/learn/DetailSidebar';
import DetailCard from '@business/components/learn/DetailCard';
import DetailInfo from '@business/components/learn/DetailInfo';
import DetailLianbaoCard from '@business/components/learn/DetailLianbaoCard';
import PageLoading from '@business/components/common/PageLoading';
import SkeletonList from '@business/components/SkeletonList';
import config from '~/environment';
import Cookies from 'js-cookie';
import api from '~/api';
import getCourseDetailFromServer from '~/api/ssr/learn';
import Modal from '~/components/study/Modal.vue';
import vueQr from 'vue-qr';
import qs from 'qs';
import {getSignUpPathTag} from '@base/constants/signUpPathSource';
import {DEFAULT_DESCRIPTION, P_CLIENT_TITLE} from '@base/constants/common';
import {addOrderTagToParams} from '@base/constants/signUpPathSource';
import getLeads from '@base/mixins/getLeads';
import {EVENT_ID_PRODUCT_VIEW} from '@base/constants/product';
import productAction from '@base/mixins/productAction';

/* 区分链接进入还是课程卡片进入，FLAG=false是链接进入 */
let FLAG = false;

// 轮询时，前端兜底的默认数据
const GET_CODE_API_DEFAULT_DATA = {
    QRCode: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQG48TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAycVIzVWdPVEpmbmkxMDAwME0wN2UAAgS4ublhAwQAAAAA',
    display: {
        bottom: '长按识别二维码或截图保存后打开微信识别二维码',
        title: '报名成功',
        top: '关注公众号，接收重要提醒'
    },
    source: 'pubQrcode',
};
// 轮询一次的时间间隔
const POLLING_TIME = 500;

// 压测时间
const MAX_TIMW = 5000;

// 高途-报名成功弹窗-我的课程按钮点击
const STUDY_CLICK = 9542223744886784;
// 高途-0元课报名后引导弹窗曝光
const CODE_SHOW = 9542202978625536;

function report(vm, param) {
    try {
        vm.$habo.perf({
            // fsp:页面图片加载完成时间
            fsp: Date.now() - window.performance.timing.navigationStart,
            ...param
        });
    }
    catch (e) {
        // pass
    }
}

export default {
    name: 'Learn',
    components: {
        DetailCard,
        DetailLianbaoCard,
        DetailInfo,
        DetailSidebar,
        PageLoading,
        SkeletonList,
        vueQr,
    },

    mixins: [performance, getLeads, productAction],
    validate({params}) {
        return /^\d+(\d|_[a-zA-Z\d]+)$/.test(params.course_id);
    },
    data() {
        return {
            // 倒计时3s
            count: 3,
            res: {},
            title: '课程详情',
            description: '',
            isFetching: true,
            params: {
                web_version: '1.1.0',
                direct_play: true
            },
            // 在服务端请求数据下进行渲染组件
            renderBasic: true,
            // 记录服务端请求数据状态
            requestData: false,
            qrCodeUrl: '',
            accessCheckFinished: false,
            stopSaleStatus: 0,
            wxTipPollingTimer: null,
            maxTimer: null,
            divideIntoClassLoading: false,
            stopPolling: false,
            clazzNumber: '',
            returnData: {
                QRCode: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQG48TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAycVIzVWdPVEpmbmkxMDAwME0wN2UAAgS4ublhAwQAAAAA',
                display: {
                    bottom: '长按识别二维码或截图保存后打开微信识别二维码',
                    title: '报名成功',
                    top: '关注公众号，接收重要提醒'
                },
                source: 'pubQrcode',
            }
        };
    },
    head() {
        return {
            title: `${this.title} - 高途素养`,
            meta: [
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: `${this.title},高途素养`
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: `${this.description}${DEFAULT_DESCRIPTION}`
                }
            ]
        };
    },
    computed: {
        ...mapState({
            token: state => state.token,
            p_client: state => state.p_client
        }),
        courseId() {
            const {course_id = 0} = this.$route.params;
            return `${course_id}`.split('_')[0];
        },
        codeTopMessage() {
            return this.returnData.display?.top || '请进入学习中心查看预约的课程';
        },
        utmData() {
            const utm_source = window.sessionStorage.getItem('utm_source') || '';
            const utm_term = window.sessionStorage.getItem('utm_term') || '';
            return {
                utm_source,
                utm_term
            };
        }
    },
    watch: {
        divideIntoClassLoading(val, oldVal) {
            try {
                const userinfo = JSON.parse(Cookies.get('__user_info__'));
                const params = {
                    calzz_number: this.courseId,
                    index: userinfo.nationalMobile,
                    source: this.returnData.source
                };
                if (val === false && val === !oldVal) {
                    this.$habo.haboViewPage(CODE_SHOW, params);
                }
            }
            catch (e) {
                console.error(e);
            }
        }
    },
    async asyncData({app, req, params, route, query, redirect}) {
        const userAgent = (process.server
            ? req.headers['user-agent']
            : navigator.userAgent) || '';
        const client = userAgent.toLowerCase().match(/(iphone|ipod|ipad|android)/);
        if (client) {
            return redirect(`https:${config.env.mUrl}${route.fullPath}`);
        }
        const initData = {
            title: '课程详情',
            res: {},
            isFetching: true
        };
        if (process.server) {
            try {
                const detailsData = await getCourseDetailFromServer({app, params, query});
                return {
                    title: detailsData.title || '课程详情',
                    description: detailsData?.link_share?.content || '',
                    res: {...detailsData},
                    requestData: detailsData.requestData,
                    renderBasic: detailsData.renderBasic,
                    isFetching: false
                };
            }
            catch (error) {
                console.log(error);
                return initData;
            }
        }
        return initData;
    },
    created() {
        if (!process.server) {
            const accessType = this.res.accessType || this.$store.state.accessType;
            if (accessType === 1) {
                this.$store.commit('SET_ACCESS_TYPE', 1);
                this.checkSpecificCourseRight();
            }
            else {
                this.accessCheckFinished = true;
            }
            this.handleAsyncDataByClient();
        }
    },
    beforeMount() {
        this.getQrCodeUrl();
    },
    mounted() {
        this.$store.commit('SET_COURSEID', this.courseId);
        // 判断是否在服务端取回了detail数据
        if (this.requestData) {
            // 服务端拿到数据后
            this.handleByDetailInfo();
        }
        else {
            // 从客户端请求数据
            this.getCourseDetailFromClient(
                {
                    ...this.params,
                    course_id: this.courseId,
                    ...this.$route.query
                }
            );
        }
    },
    methods: {
    // 详情页pv上报
        async handleReportPageView() {
            const { course_type } = this.res;
            await this.handleSourceToLeadsId();
            this.$habo.haboViewPage(
                EVENT_ID_PRODUCT_VIEW,
                {
                    product_number: this.courseId,
                    product_type: course_type,
                    leads_id: this.leadsId || '',
                    page_from: 'oldProduct'
                }
            );
        },
        // source转leadsIS
        handleSourceToLeadsId() {
            const { source } = this.$route.query;
            const { course_type } = this.res;
            // 如果详情页上有source，获取leadsId
            if (source) {
                try {
                    this.sourceInit({
                        source,
                        pageType: 13,
                        skuIdType: {
                            skuId: this.productNumber,
                            // 组合传2，单课传1
                            skuType: [23, 51].includes(course_type) ? 2 : 1
                        }
                    });
                }
                catch (error) {
                    console.log('获取leadsId失败');
                }
            }
        },
        // 轮询
        handlePolling({fn, grade, orderId}) {
            // 如果wxTipPollingTimer存在，清除并赋初值
            if (this.wxTipPollingTimer) {
                clearTimeout(this.wxTipPollingTimer);
                this.wxTipPollingTimer = null;
                this.divideIntoClassLoading = false;
            }
            // 如果maxTimer存在，清除并赋初值
            if (this.maxTimer) {
                clearTimeout(this.maxTimer);
                this.maxTimer = null;
                this.stopPolling = false;
            }
            // 开启加载
            this.divideIntoClassLoading = true;
            // 开启最大压测时间计时
            this.maxTimer = setTimeout(() => {
                // 到压测时间，轮询结束标志为true，关闭loading
                this.stopPolling = true;
                this.divideIntoClassLoading = false;
                // 特殊情况处理，第一次接口penging中，超过设定的压测时间，返回前端设置的默认值
                if (this.isEmpty(this.returnData)) {
                    this.returnData = GET_CODE_API_DEFAULT_DATA;
                }
                clearTimeout(this.maxTimer);
            }, MAX_TIMW);
            // 第一次轮询请求接口
            this.wxTipPollingTimer = setTimeout(() => {
                fn({grade, orderId});
            }, POLLING_TIME);
        },
        // 公开课报名成功后二维码相关数据
        getCode({grade, orderId}) {
            if (this.stopPolling) {
                clearTimeout(this.wxTipPollingTimer);
                if (this.isEmpty(this.returnData)) {
                    this.returnData = GET_CODE_API_DEFAULT_DATA;
                }
                this.divideIntoClassLoading = false;
                if (this.isGtqscz) {
                    this.$modal.hide('apply-success-popup');
                    this.$toasted.show(
                        '恭喜您预约并分班完成', {
                            position: 'top-center',
                            duration: 1500,
                        }
                    )
                }
                return;
            }
            const options = {params: {os: 'h5-pc'}};
            this.$axios.$post(api.order.getPublicClassQrCode, qs.stringify({
                grade,
                orderId,
                // 1:PC  2:M站免费公开课  3:M站付费公开课
                codeEnum: 1,
                courseId: this.courseId
            }), options).then(res => {
                clearTimeout(this.wxTipPollingTimer);
                // 添加 !this.stopPolling 防止已经请求出去的接口pending中，超过压测时间返回值覆盖已有的值
                if (res.code === 0 && !this.stopPolling) {
                    // data 有{} 的情况。
                    this.returnData = this.isEmpty(res.data)
                        ? this.returnData
                        : {
                            ...this.returnData,
                            QRCode: res.data.QRCode,
                            display: res.data.display || GET_CODE_API_DEFAULT_DATA.display,
                            source: res.data.source
                        };
                    // 后端告诉结束标志，关闭loading，结束轮询
                    if (res.data.finalStatus === 1) {
                        this.divideIntoClassLoading = false;
                        if (this.isGtqscz) {
                            this.$modal.hide('apply-success-popup');
                            this.$toasted.show(
                                '恭喜您预约并分班完成', {
                                    position: 'top-center',
                                    duration: 1500,
                                }
                            )
                        }
                    }
                    else {
                        this.wxTipPollingTimer = setTimeout(() => {
                            this.getCode({grade, orderId});
                        }, POLLING_TIME);
                    }
                }
                // code 不为0的情况，启动下一次轮询。
                else {
                    this.wxTipPollingTimer = setTimeout(() => {
                        this.getCode({grade, orderId});
                    }, POLLING_TIME);
                }
            }).catch(() => {
                clearTimeout(this.wxTipPollingTimer);
                // 是否过了压测时间，没有则继续轮询
                if (this.stopPolling) {
                    if (this.isEmpty(this.returnData)) {
                        this.returnData = GET_CODE_API_DEFAULT_DATA;
                    }
                    this.divideIntoClassLoading = false;
                }
                else {
                    this.wxTipPollingTimer = setTimeout(() => {
                        this.getCode({grade, orderId});
                    }, POLLING_TIME);
                }
            });
        },
        // 判断是否为空对象
        isEmpty(obj) {
            return Object.keys(obj).length === 0
        },
        async checkSpecificCourseRight() {
            try {
                const res = await this.$axios.$post(
                    api.order.checkCanBuy,
                    {clazzNumbers: [this.courseId]},
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );
                const code = res.code || res.status;
                if (code === 16 || code === 29) {
                    return;
                }

                const data = res.data || {};
                if (code !== 0 || data.accessResult === 2) {
                    return this.$router.replace({path: '/busy'});
                }

                this.accessCheckFinished = true;
            }
            catch (e) {
                this.$router.replace({path: '/busy'});
            }
        },
        // 二维码图片链接
        getQrCodeUrl(targetUrl) {
            let originalQuery = '';
            try {
                originalQuery = window.location.href.split('?')[1];
            }
            catch (e) {
                // pass
            }

            const {
                seller_id
            } = this.$route.query;

            let targetQuery = seller_id ? qs.stringify({seller_id}) : '';
            targetQuery = targetQuery ? `&${targetQuery}` : '';

            const signUpPathTag = getSignUpPathTag();
            const signUpPathTagQuery = signUpPathTag ? `&signUpPathTag=${signUpPathTag}` : '';

            if (targetUrl) {
                this.qrCodeUrl = `https:${config.env.mUrl}${targetUrl}${targetQuery}${signUpPathTagQuery}`;
                return;
            }

            let queryString = '';
            if (originalQuery) {
                queryString = `linkFrom=pc&${originalQuery}`;
            }
            else {
                queryString = 'linkFrom=pc';
            }

            this.qrCodeUrl = `https:${config.env.mUrl}/learn/${this.courseId}?${queryString}`;
        },
        handleLianbaoNeed(url) {
            this.getQrCodeUrl(url);
            this.$modal.show('apply-qrcode-popup');
        },
        // 重定向
        handleAsyncDataByClient() {
            const deviceAgent = window.navigator.userAgent.toLowerCase();
            const agentID = deviceAgent.match(/(iphone|ipod|ipad|android)/);
            if (agentID) {
                window.location.href = `${window.location.protocol
                    + config.env.mUrl}learn/${this.courseId}?${
                    this.$route.fullPath.split('?')[1]
                }`;
            }
        },
        // 从服务端取回detail数据或者客户端请求详情页数据的后续操作
        handleByDetailInfo() {
            this.setBaseInfo();

            const {
                res,
                token
            } = this;
            const {
                source,
                autoPlaying,
                ordering,
                seller_id,
                counselor_id,
                sourceOpenId
            } = this.$route.query;
            if (res.course_type === 1) {

                /* 链接进入自动播放 */
                setTimeout(() => {
                    this.onAutomaticExecutionHandler(res);
                }, 0);
                // 后置登录的两个情况
                //  自动播放和自动预约
                //
                if (autoPlaying === 1 && !this.isGtqscz) {
                    this.onGoAutoPlay(res);
                }
                if (ordering === 1) {
                    this.nologinOrder(res);
                }
            }
            // 销售相关
            let clazz_numbers = [];
            if (res.sub_clazz_list && res.sub_clazz_list.length > 0) {
                clazz_numbers = res.sub_clazz_list.map(item => item.clazz_number);
            }
            if (seller_id) {
                Cookies.set(
                    'seller',
                    {
                        seller_id,
                        product_id: res.enroll_pid || res.course_id,
                        clazz_numbers
                    },
                    {
                        expires: 30,
                        path: '/'
                    }
                );
                const valmsg = `seller_id=${seller_id}`;
                // eslint-disable-next-line no-undef
                _czc.push([
                    '_trackEvent',
                    'page-learn',
                    'show',
                    valmsg,
                    1,
                    'page-learn-seller_id'
                ]);
            }
            if (counselor_id) {
                Cookies.set(
                    'counselor',
                    {
                        counselor_id,
                        product_id: res.enroll_pid || res.course_id,
                        clazz_numbers
                    },
                    {
                        expires: 30,
                        path: '/'
                    }
                );
                const valmsg = `counselor_id=${counselor_id}`;
                // eslint-disable-next-line no-undef
                _czc.push([
                    '_trackEvent',
                    'page-learn',
                    'show',
                    valmsg,
                    1,
                    'page-learn-counselor_id'
                ]);
            }
            if (token) {
                if (Cookies.get('sourceOpenId')) {
                    Cookies.remove('sourceOpenId');
                }
            }
            else {
                if (sourceOpenId) {
                    Cookies.set('sourceOpenId', sourceOpenId, {
                        expires: 30,
                        path: '/'
                    });
                }
                const valmsg = `source=${sourceOpenId}`;
                // eslint-disable-next-line no-undef
                _czc.push([
                    '_trackEvent',
                    'page-learn',
                    'show',
                    valmsg,
                    1,
                    'page-learn-source'
                ]);
            }
            // 详情页PV上报
            this.handleReportPageView();
        },
        // 记录课程信息并获取promotion信息
        setBaseInfo() {
            const {course_type: courseType, clazz_set_list = [], price, stopSaleStatus = 0} = this.res;
            if (stopSaleStatus === 2) {
                this.$router.replace({path: '/category'});
            }
            else {
                this.stopSaleStatus = stopSaleStatus;
            }
            let activityNumber = 0;
            if (clazz_set_list.length > 0) {
                const {activity_number = '0'} = clazz_set_list[0];
                activityNumber = activity_number;
            }
            this.$store.commit('course/SET_BASE_INFO', {
                courseId: this.courseId,
                courseType,
                activityNumber,
                price
            });
            this.$store.dispatch('course/GET_PROMOTION_DETAIL');
        },

        /* 后置登录自动播放 */
        onGoAutoPlay(payload) {
            // eslint-disable-next-line no-unused-vars
            const params = {
                product_id: payload.enroll_pid,
                course_type: payload.course_type
            };
            if (payload.direct_play && payload.direct_play.action === 1) {
                this.$store.dispatch('GET_LIVE_URL', {live_id: payload.direct_play.live_id, ...this.$route.query});
            }
            else if (payload.content_type === 1 && payload.direct_play && payload.direct_play.action === 2) {
                if (this.p_client === 12) {
                    window.open(`https:${config.env.pcUrl}/live/playbackList/${payload.direct_play.live_id}?counselor_id=${this.$route.query.counselor_id}`)
                }
                else {
                    this.$router.push({
                        path: `/live/playbackList/${payload.direct_play.live_id}`,
                        query: {
                            counselor_id: this.$route.query.counselor_id
                        }
                    });
                }
            }
        },

        /* 倒计时方法 */
        goGrdoupRecor(res) {
            if (!this.timer) {
                this.timer = setInterval(() => {
                    if (this.count > 0) {
                        this.count--;
                    }
                    else if (this.count === 0) {
                        if (res.direct_play && res.direct_play.action === 1) {
                            this.$store.dispatch('GET_LIVE_URL_W',
                                                 {live_id: res.direct_play.live_id, ...this.$route.query});
                        }
                        else if (
                            res.direct_play && res.direct_play.action === 2
                        ) {
                            if (this.p_client === 12) {
                                window.open(`https:${config.env.pcUrl}/live/playbackList/${res.direct_play.live_id}?counselor_id=${this.$route.query.counselor_id}`)
                            }
                            else {
                                this.$router.push({
                                    path: `/live/playbackList/${res.direct_play.live_id}`,
                                    query: {
                                        counselor_id: this.$route.query.counselor_id
                                    }
                                });
                            }
                        }
                        clearInterval(this.timer);
                        this.timer = null;
                        this.count = 3;
                        this.$modal.hide('countdown-popup');
                    }
                }, 1000);
            }
        },

        /* 弹窗内方法 */
        onCloseHandler() {
            // 取消
            this.$modal.hide('countdown-popup');
            clearInterval(this.timer);
            this.timer = null;
            this.count = 3;
        },
        onCloseApplySuccessPopupHander() {
            // 叉
            this.$modal.hide('apply-success-popup');
            this.$modal.hide('countdown-popup');
            clearInterval(this.timer);
            this.timer = null;
            this.count = 3;
        },
        onCloseApplyQrcodePopupHander() {
            // 二维码叉
            this.$modal.hide('apply-qrcode-popup');
        },
        onGotoPLaybackList(payload) {
            // 看回放时的立即观看
            if (this.p_client === 12) {
                window.open(`https:${config.env.pcUrl}/live/playbackList/${payload.live_id}?counselor_id=${this.$route.query.counselor_id}`)
            }
            else {
                this.$router.push({
                    path: `/live/playbackList/${payload.live_id}`,
                    query: {
                        counselor_id: this.$route.query.counselor_id
                    }
                });
            }
        },
        onLivehandler(payload) {
            // 直播中时的立即观看
            this.$store.dispatch('GET_LIVE_URL', {live_id: payload.direct_play.live_id, ...this.$route.query});
            this.$modal.hide('countdown-popup');
            clearInterval(this.timer);
            this.timer = null;
            this.count = 3;
        },
        onBeforeCloseApplySuccessPopupHander() {
            if (this.res.is_open_course) {
                window.location.reload();
            }
            else if (this.res.order_id) {
                if (this.p_client === 12) {
                    window.open(`https:${config.env.pcUrl}/account/orders/detail?order_id=${this.res.order_id}`)
                }
                else {
                    this.$router.push({
                        path: '/account/orders/detail',
                        query: {order_id: this.res.order_id}
                    });
                }
            }
            else {
                window.location.reload();
            }
            this.res = {};
        },

        /**
         * 微信销售渠道来源记录新需求
         * url上带有sourceOpenId时，用户已经登录，第一次打开详情页时，访问详情页接口时新增参数sourceOpenId和newOpen=1
         */
        // eslint-disable-next-line max-lines-per-function
        getCourseDetailFromClient(params) {
            if (this.$route.query.source) {
                Cookies.set('__SOURCECHANNEL__', this.$route.query.source, {
                    expires: 30,
                    path: '/'
                });
            }
            if (Cookies.get('sourceOpenId')) {
                params.sourceOpenId = Cookies.get('sourceOpenId');
                params.newOpen = 0;
            }
            else if (this.$route.query.sourceOpenId) {
                params.sourceOpenId = this.$route.query.sourceOpenId;
                params.newOpen = 1;
            }
            // 销售相关
            if (this.$route.query.main_id) {
                params.optional_main_course_id = this.$route.query.main_id;
            }
            if (this.$route.query.sharer_student_number) {
                params.sharer_student_number = this.$route.query.sharer_student_number;
            }
            if (this.$route.query.counselor_id) {
                params.counselor_id = this.$route.query.counselor_id;
            }
            this.res = {};
            const requestStart = Date.now();
            let requestEnd = 0;
            this.isFetching = true;
            this.$axios.$get(api.course.detail, {params}).then(res => {
                this.isFetching = false;
                if (res.status === 0) {
                    this.title = res.title || '课程详情';
                    this.description = res?.link_share?.content || '';
                    if (res.stopSaleStatus === 2) {
                        this.$router.replace({path: '/category'});
                    }
                    else {
                        this.stopSaleStatus = res.stopSaleStatus || 0;
                    }
                    this.res = {...res};
                    // 上报自定义性能打点
                    if (!FLAG) {
                        requestEnd = Date.now();
                        this.$nextTick(() => {
                            report(this, {
                                fr: requestEnd - requestStart
                            });
                        });
                    }
                    this.handleByDetailInfo();
                }
            });
        },

        /* 课程卡片进入未登录，登录后自动预约 */
        nologinOrder(payload) {
            if (payload.content_type === 2) {
                const params = {
                    productId: payload.enroll_pid,
                    courseType: payload.course_type,
                    checkNotPayOrder: true,
                    isFromH5: false,
                    utmData: this.utmData
                };
                const {counselor_id, seller_id, salesId, source} = this.$route.query;
                if (counselor_id) {
                    params.counselor_id = counselor_id;
                }
                if (seller_id || salesId) {
                    params.sellerId = seller_id || salesId;
                    params.salesId = seller_id || salesId;
                }
                addOrderTagToParams(params);
                this.$axios.$post(api.order.createForFreeCourse, qs.stringify(params)).then(res => {
                    this.isFetching = false;
                    if (res.status === 0) {
                        if (this.p_client === 12) {
                            window.open(`https:${config.env.pcUrl}/apply/${params.product_id}?courseType=${params.course_type}&grade=${payload.grade}`)
                        }
                        else {
                            this.$router.push({
                                path: `/apply/${params.product_id}`,
                                query: {
                                    courseType: params.course_type,
                                    grade: payload.grade
                                }
                            });
                        }
                    }
                    // eslint-disable-next-line no-magic-numbers
                    if (res.status === 445) {
                        this.clazzNumber = res.data?.orderInfos[0]?.clazzNumber;
                        this.handlePolling({fn: this.getCode, grade: payload.grade, orderId: res.data.order_id});
                        this.$modal.show('apply-success-popup');
                    }
                });
            }
        },

        /* 链接进入 */
        onAutomaticExecutionHandler(payload) {
            if (!FLAG && !this.isGtqscz) {
                if (!this.token) {
                    this.$store.commit('SET_ISSHOWLOGIN', true);
                }
                else if (payload.content_type === 1) {
                    if (payload.direct_play && payload.direct_play.action === 1) {
                        this.$modal.show('countdown-popup');
                        this.goGrdoupRecor(payload);
                    }
                    else if (payload.direct_play && payload.direct_play.action === 2) {
                        // 公开课，判断回放天数playbackDay字段，-1代表不提供回放，不回放不给自动跳转的弹窗
                        if (payload.playback_day !== -1) {
                            this.$modal.show('countdown-popup');
                            this.goGrdoupRecor(payload);
                        }
                    }
                }
                else if (payload.content_type === 2 && payload.enroll_status === 1) {
                    const params = {
                        productId: payload.enroll_pid,
                        courseType: payload.course_type,
                        checkNotPayOrder: true,
                        isFromH5: false,
                        utmData: this.utmData
                    };
                    const {counselor_id, seller_id, salesId, source} = this.$route.query;
                    if (counselor_id) {
                        params.counselorId = counselor_id;
                    }
                    if (seller_id || salesId) {
                        params.sellerId = seller_id || salesId;
                        params.salesId = seller_id || salesId;
                    }
                    addOrderTagToParams(params);
                    this.$axios.$post(api.order.createForFreeCourse, qs.stringify(params)).then(res => {
                        this.isFetching = false;
                        if (res.status === 0) {
                            if (this.p_client === 12) {
                                window.open(`https:${config.env.pcUrl}/apply/${params.productId}?courseType=${params.courseType}&grade=${payload.grade}`)
                            }
                            else {
                                this.$router.push({
                                    path: `/apply/${params.productId}`,
                                    query: {
                                        courseType: params.courseType,
                                        grade: payload.grade
                                    }
                                });
                            }
                        }
                        // eslint-disable-next-line no-magic-numbers
                        if (res.status === 445 && payload.direct_play.action === 0) {
                            this.clazzNumber = res.data?.orderInfos[0]?.clazzNumber;
                            this.handlePolling({fn: this.getCode, grade: payload.grade, orderId: res.data.order_id});
                            this.$modal.show('apply-success-popup');
                        }
                        // eslint-disable-next-line no-magic-numbers
                        else if (res.status === 445 && payload.direct_play && payload.direct_play.action === 1) {
                            this.$modal.show('countdown-popup');
                            this.goGrdoupRecor(payload);
                        }
                        // eslint-disable-next-line no-magic-numbers
                        else if (res.status === 445 && payload.direct_play && payload.direct_play.action === 2) {
                            this.$modal.show('countdown-popup');
                            this.goGrdoupRecor(payload);
                        }
                        // eslint-disable-next-line no-magic-numbers
                        if (res.status === 440) {
                            this.$modal.hide('stater-common-popup');
                        }
                    });
                }
            }
        },
        handleClick(e) {
            if (e?.target?.nodeName === 'A') {
                this.$habo.haboClickReport(STUDY_CLICK);
            }
        }
    },

    /* 区分链接进入还是课程卡片进入 */
    beforeRouteEnter(to, from, next) {
        if (from.name) {
            FLAG = true;
        }
        else {
            FLAG = false;
        }
        next(vm => {
            vm.routeFrom = from;
        });
    },
    //TODO：增加成人模块后，直接通过链接进入成人详情页，因为接口grade和subject未正常返回，此时切回选课中心后，科目tab会显示为空，先注销后续优化
    // beforeRouteLeave(to, from, next) {
    //     if (to.fullPath === '/category') {
    //         this.$store.commit('GRADE', {grade: this.res.grade});
    //         this.$store.commit('SUBJECT', {subject: this.res.subject || 0});
    //     }
    //     next();
    // }
};
</script>
<style lang="less" scoped>
button {
    border: 0;

    background-color: transparent;

    outline: none;
}

.section-container {
    min-height: calc(100vh - 288px);
    padding-bottom: 76px;
    margin-top: 24px;

    .wrapper {
        width: 1200px;
    }
}

.course-detail-page {
    position: relative;
    width: 100%;

    .detail-right {
        position: absolute;
        right: 0;
        top: 0;
        width: 320px;
    }

    .detail-left {
        width: 832px;
    }
}

.apply-success-popup {
    position: relative;
    padding-bottom: 39px;

    .popup__head {
        position: relative;
        font-size: 20px;
        // font-weight: 500;
        text-align: center;
        color: #32404b;
        line-height: 20px;
        padding: 30px 0;

        .icon-xuanzhong {
            font-size: 24px;
            padding-right: 14px;
            color: #07b906;
            display: inline-block;
            vertical-align: bottom;
        }

        .icon-guanbi {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 18px;
            line-height: 18px;
            color: #bfbfbf;
            display: block;
            cursor: pointer;
        }
    }

    .line {
        display: block;
        width: 310px;
        height: 1px;
        background-color: #ebebeb;
        margin-left: 30px;
    }

    .popup__body {
        position: relative;
        margin: 0 30px;
        text-align: center;

        .apply-top {
            width: 280px;
            height: 20px;
            font-size: 12px;

            // font-weight: 500;
            color: #32404b;
            line-height: 20px;
            margin-top: 10px;
            margin-left: 15px;
        }

        .apply-content {
            position: relative;
            display: table;
            width: 100%;
        }

        .apply-wechat-code {
            display: table-cell;
            width: 150px;
            height: 150px;

            img {
                width: 100%;
                height: auto;
                vertical-align: top;
                margin-left: 80px;
                margin-top: 12px;
            }
        }

        .apply-wechat-footer {
            height: 48px;
            font-size: 16px;

            font-weight: 400;
            color: #818a92;
            line-height: 24px;
            margin-top: 10px;
            margin-left: 20px;

            span:nth-of-type(1) {
                text-align: center;
                display: block;
            }
        }
    }
}

.apply-qrcode-modal {
    box-shadow: 0 0 #fff;
}

.apply-qrcode-popup {
    position: relative;
    width: 230px;
    height: 210px;
    padding-top: 26px;

    .popup_qrcode {
        font-size: 16px;
        line-height: 12px;
        color: #32404b;
        font-family: PingFangSC;
        text-align: center;
    }

    .qrcode_img {
        margin-top: 20px;
    }

    .icon-qrcode-guanbi {
        position: absolute;
        top: 18px;
        right: 20px;
        font-size: 16px;
        line-height: 16xpx;
        color: #bfbfbf;
        display: block;
        cursor: pointer;
    }
}

.countdown-popup {
    position: relative;
    padding-bottom: 30px;

    .popup__head {
        position: relative;
        font-size: 20px;
        text-align: center;
        color: #32404b;
        line-height: 20px;
        padding: 30px 0;

        .icon-xuanzhong {
            font-size: 24px;
            padding-right: 14px;
            color: #07b906;
            display: inline-block;
            vertical-align: bottom;
        }

        .icon-guanbi {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 18px;
            line-height: 18px;
            color: #bfbfbf;
            display: block;
            cursor: pointer;
        }
    }

    .line {
        display: block;
        width: 310px;
        height: 1px;
        background-color: #ebebeb;
        margin-left: 30px;
    }

    .popup__body {
        position: relative;
        margin: 15px 30px 24px;
        width: 310px;
        height: 60px;
        font-size: 20px;
        color: #32404b;
        line-height: 30px;
        text-align: center;

        .time {
            color: #f63232;
        }
    }

    .quxiao_btn {
        position: relative;
        width: 140px;
        height: 44px;
        border-radius: 4px;
        border: 1px solid #f63232;
        font-size: 20px;
        color: #f63232;
        line-height: 20px;
        margin-left: 35px;
        margin-right: 20px;
    }

    .enter_btn {
        position: relative;
        width: 140px;
        height: 44px;
        background: #f63232;
        border-radius: 4px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        line-height: 20px;
    }
}
/deep/ .to-study {
    color: #0890ff;
}
</style>
